import { STATIC_FILE_PATH } from "@shared/env";

/**
 * Adds static file path to the beginning of the path
 * returns "static/media/images/my_image.jpg" given
 * "/images/my_image.jpg" and STATIC_FILE_PATH = "static/media"
 *
 * Use this to get the relative path for files uploaded
 * from NextJS to the CDN.
 */
const formatRelativeStaticPath = (path: string): string => {
  let formattedPath = path;
  let formattedStaticPath = STATIC_FILE_PATH;
  // if path starts with a slash, remove it
  if (formattedPath.startsWith("/")) {
    formattedPath = path.slice(1);
  }
  // if static file path does not end with a slash, add it
  if (!STATIC_FILE_PATH?.endsWith("/")) {
    formattedStaticPath = `/${formattedStaticPath}`;
  }
  // if static file path begins with a slash, remove it
  if (STATIC_FILE_PATH?.startsWith("/")) {
    formattedStaticPath = formattedStaticPath.slice(1);
  }
  return `${formattedStaticPath}${formattedPath}`;
};

// Get image source otherwise display default banner from static files
const getEventImageSource = (
  event:
    | {
        image_banner?: string | undefined;
      }
    | undefined
): string => {
  // default image
  if (event?.image_banner) {
    return event.image_banner;
  }
  const imageSource = formatRelativeStaticPath("images/default-banner.png");
  return imageSource;
};

export { formatRelativeStaticPath, getEventImageSource };
